import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { SSRMeasures } from '@confluence/action-measures/entry-points/SSRMeasures.ts';
import { preloadWebItemLocation } from '@confluence/web-item-location/entry-points/preloadWebItemLocation.ts';
import { preloadEditButton } from '@confluence/edit-button/entry-points/preloadEditButton.js';
import { preloadWatchDialog } from '@confluence/watch-dialog/entry-points/preloadWatchDialog.ts';
import { isCompanyHubSpaceKey } from '@confluence/route-manager/entry-points/companyHubUtils.ts';

import { preloadSpaceStarTextButton } from './preloadSpaceStarTextButton.ts';

export type preloadGroupedButtonsProps = {
	contentId: string;
	spaceKey: string;
	userId: string | null;
	isLicensed: boolean;
	shouldPreloadUsingSpaceKey?: boolean;
};

export function preloadGroupedButtons({
	contentId,
	spaceKey,
	userId,
	isLicensed = false,
}: preloadGroupedButtonsProps) {
	/**
	 * Watch dialog button:
	 * next/packages/ssr-app/src/module-replacements/@confluence/watch-dialog.js
	 *
	 * "..." button:
	 * See next/packages/ssr-app/src/module-replacements/@confluence/content-tools.js
	 *
	 * Share button:
	 * See next/packages/ssr-app/src/module-replacements/@confluence/share.js
	 */
	return SSRMeasures.run('ssr-app/prepare/preloadQuery/fetch:pageButtons', async () => {
		const tasks: Promise<any>[] = [preloadEditButton({ spaceKey, contentId })];
		const isCompanyHub = isCompanyHubSpaceKey(spaceKey);
		if (!isCompanyHub) {
			// Determine whether to show restriction and share button
			tasks.push(
				preloadWebItemLocation({
					location: 'system.content.button',
					// Special case when we know the content id the code in SpaceOverviewGroupedButtons only cares about content id
					...(contentId ? { contentId } : { spaceKey }),
				}),
				preloadWatchDialog({
					spaceKey,
					isLicensed,
					userId,
					contentId,
				}),
				preloadSpaceStarTextButton(spaceKey),
			);
		}

		return waitForAllReturnWhenError(tasks);
	});
}
